import { Loadable } from 'components/common';
import { useOmniHistoriesLeadManageContext } from 'contexts';
import { twMerge } from 'tailwind-merge';
import { ChatSessionDto } from 'types';
import {
  OmniChannelLeadChatHistoriesChatBox,
  OmniChannelLeadChatHistoriesFilterForm,
  OmniChannelLeadChatHistoriesSessionList
} from 'components/omni-channel-chat-histories';
import { Typography } from 'antd';
import { omniChatMessages } from 'messages';
import HistoryChatDetails from './HistoryChatDetails';

type ChatHistoriesTabProps = {
  onSelectCustomer?: (value?: ChatSessionDto) => void;
  selectedCustomerId?: number;
};

const ChatHistoriesTab: React.FC<ChatHistoriesTabProps> = ({ onSelectCustomer, selectedCustomerId }) => {
  const { chatHistory } = useOmniHistoriesLeadManageContext();

  return (
    <div className='flex h-full w-full flex-1'>
      <div className={twMerge('h-full w-[400px] shrink-0 rounded-bl-xl border-r', 'bg-colorBgItemHover')}>
        <div className='flex max-h-[calc(100vh-220px)] flex-1 flex-col overflow-hidden'>
          <div className='flex h-16 shrink-0 items-center border-b px-5'>
            <Typography.Text className='mb-0 text-lg font-semibold'>{omniChatMessages.findChatSession}</Typography.Text>
          </div>

          <div className='max-h-full w-full overflow-y-auto overflow-x-hidden'>
            <OmniChannelLeadChatHistoriesFilterForm />
          </div>
        </div>
      </div>
      {chatHistory && (
        <div
          className={twMerge(
            'h-full w-full border-r transition-all duration-200',
            chatHistory ? '-translate-x-0' : 'translate-x-full'
          )}
        >
          <Loadable>
            <OmniChannelLeadChatHistoriesChatBox chatSession={chatHistory} />
          </Loadable>
        </div>
      )}
      {chatHistory && (
        <div
          className={twMerge(
            'w-[360px] shrink-0 rounded-xl bg-white transition-all duration-200 2xl:w-[468px]',
            chatHistory ? 'translate-x-0' : 'translate-x-full'
          )}
        >
          <HistoryChatDetails />
        </div>
      )}
      {!chatHistory && <OmniChannelLeadChatHistoriesSessionList />}
    </div>
  );
};

export default ChatHistoriesTab;
